module.exports = __webpack_public_path__ + "static/media/why_choos.86ca4c95.jpg";